import { IKeyedInDetails } from "./KeyedInDetails";

export default interface IKeyedInDetailsData {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    measurementId: string;
    orderId: string;
    setId: string;
    keyedInDetails: IKeyedInDetails[],
    lastEnteredValue?: string
}

export class KeyedInDetailsData implements IKeyedInDetailsData {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    measurementId: string;
    orderId: string;
    setId: string;
    keyedInDetails: IKeyedInDetails[];
    lastEnteredValue?: string;
   
    constructor(id: string,
        name: string,
        description: string,
        isEnabled: boolean,
        measurementId: string,
        orderId: string,
        setId: string,
        keyedInDetails: IKeyedInDetails[],
        lastEnteredValue?: string
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.isEnabled = isEnabled;
        this.measurementId = measurementId;
        this.orderId = orderId;
        this.setId = setId;
        this.keyedInDetails = keyedInDetails;
        this.lastEnteredValue = lastEnteredValue;
    }
}

const defaultKeyedInDetailsData = new KeyedInDetailsData("", "", "", false, "", "", "", [],"");
export { defaultKeyedInDetailsData };
